import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { Link } from "react-router-dom"
import { connect } from "react-redux" 
import withRouter from "../Common/withRouter";
//i18n
import { withTranslation } from "react-i18next"
import AuthorizationChecker from "security/AuthorizationChecker"

const SidebarContent = (props) => {

  const ref = useRef()
  const localLanguage = localStorage.getItem("I18N_LANGUAGE")
  const currentLanguage = localLanguage?localLanguage:'en';
  // Menu builder
  const menuBuilder = (menuItems, index = null,currentLanguage) => {
    return (
      ( ( menuItems.roles == undefined ) || ( menuItems.roles.length == 0 ) || ( menuItems.roles!=undefined && AuthorizationChecker.isGranted(menuItems.roles) ) )
      && 
      (
        <li key={index}>
          <Link to={menuItems?.link ? menuItems?.link : '#'} className={menuItems.className}>
            {
              menuItems.icon && (
                <i className={menuItems.icon}></i>
              )
            }
            <span>{menuItems?.label[currentLanguage]}</span>
          </Link>
          {
            menuItems.items && (
              <ul className={"mm-collapse"}>
                {
                  menuItems.items?.map(function (item, idx) {
                    return menuBuilder(item, idx,currentLanguage);
                  })
                }
              </ul>
            )
          }
        </li>
      )
    )
  }

  // Build menu for each menu tree
  const fullMenu = props.menuItems[0].content?.map(function (item, index) {
    return menuBuilder(item, index,currentLanguage);
  })

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = location.pathname.split("?")[0];
    const initMenu = () => {
      // Désactivé MetisMenu pour permettre le menu horizontal avec hover CSS
      // new MetisMenu("#side-menu")
      
      // Ajouter les event listeners pour afficher les dropdowns au hover
      const menuItems = document.querySelectorAll('#side-menu > li');
      
      // Détecter si on est en mode mobile
      const isMobile = () => window.innerWidth <= 991;
      
      // En mobile, s'assurer que le menu est caché au démarrage
      if (isMobile() && !document.body.classList.contains('sidebar-enable')) {
        document.body.classList.remove('sidebar-enable');
      }
      
      // Fonction pour gérer les dropdowns à tous les niveaux
      const setupDropdown = (item, index, isTopLevel = true) => {
        const dropdown = item.querySelector(':scope > .mm-collapse');
        const link = item.querySelector(':scope > a');
        
        if (dropdown) {
          
          // DESKTOP : Hover pour afficher/cacher
          item.addEventListener('mouseenter', (e) => {
            if (isMobile()) return; // Ignorer en mobile
            
            e.stopPropagation();
            
            if (isTopLevel) {
              // Menu de niveau 1 : positionner en dessous
              const rect = item.getBoundingClientRect();
              dropdown.style.top = `${rect.bottom}px`;
              dropdown.style.left = `${rect.left}px`;
            } else {
              // Sous-menu : positionner à droite
              const rect = item.getBoundingClientRect();
              dropdown.style.top = `${rect.top}px`;
              dropdown.style.left = `${rect.right}px`;
            }
            
            dropdown.style.display = 'block';
            dropdown.style.visibility = 'visible';
            dropdown.style.opacity = '1';
            
          });
          
          // Cacher quand on quitte (desktop seulement)
          item.addEventListener('mouseleave', (e) => {
            if (isMobile()) return; // Ignorer en mobile
            
            // Ne pas cacher si on entre dans le dropdown lui-même
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && dropdown.contains(relatedTarget)) {
              return;
            }
            
            dropdown.style.display = 'none';
            dropdown.style.visibility = 'hidden';
            dropdown.style.opacity = '0';
          });
          
          // MOBILE : Clic pour toggle (fonctionne toujours)
          const handleClick = (e) => {
            
            if (!isMobile()) {
              return; // Ignorer en desktop
            }
            
            // Si c'est un item avec sous-menu, bloquer la navigation et toggle
            if (dropdown) {
              e.preventDefault();
              e.stopPropagation();
              
              const isOpen = dropdown.classList.contains('show');
              
              // Fermer tous les autres dropdowns du même niveau
              const siblings = item.parentElement.querySelectorAll(':scope > li > .mm-collapse');
              siblings.forEach((sibling, idx) => {
                if (sibling !== dropdown) {
                  sibling.classList.remove('show');
                  sibling.parentElement.classList.remove('open');
                  
                  // Fermer aussi tous les sous-menus enfants
                  const childDropdowns = sibling.querySelectorAll('.mm-collapse');
                  childDropdowns.forEach(child => {
                    child.classList.remove('show');
                    child.parentElement.classList.remove('open');
                  });
                }
              });
              
              // Toggle ce dropdown
              if (isOpen) {
                dropdown.classList.remove('show');
                item.classList.remove('open');
                
                // Fermer tous les sous-menus enfants aussi
                const childDropdowns = dropdown.querySelectorAll('.mm-collapse');
                childDropdowns.forEach(child => {
                  child.classList.remove('show');
                  child.parentElement.classList.remove('open');
                });
              } else {
                dropdown.classList.add('show');
                item.classList.add('open');
              }
              
            } else {
            }
          };
          
          // Attacher sur le lien ET sur le li pour être sûr
          if (link) {
            link.addEventListener('click', handleClick);
          }
          item.addEventListener('click', handleClick);
          
          // Gérer les sous-menus de ce dropdown
          const subItems = dropdown.querySelectorAll(':scope > li');
          subItems.forEach((subItem, subIndex) => {
            setupDropdown(subItem, `${index}-${subIndex}`, false);
          });
        } else {
          console.log(`⚠️ Pas de dropdown pour item ${index}`);
        }
      };
      
      // Initialiser les dropdowns de niveau 1
      menuItems.forEach((item, index) => {
        setupDropdown(item, index, true);
      });
      
      // Fermer le menu mobile quand on clique sur l'overlay
      if (isMobile()) {
        document.body.addEventListener('click', (e) => {
          if (e.target === document.body && document.body.classList.contains('sidebar-enable')) {
            document.body.classList.remove('sidebar-enable');
          }
        });
      }
      
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")

      if(items.length==0){
        setTimeout(() => {
          initMenu()
        }, 500);
        return
      }
      /*ul.querySelectorAll("ul")
    .forEach(el => el.textContent.trim() === "" && el.parentNode.removeChild(el))*/
      let flag = true;
      for (let item of items) {
        if (pathName === item.pathname) {
          matchingMenuItem = item
          const brothers = item.parentElement.childNodes
          flag = false;
          if(brothers.length >1){
            const subItems = brothers[0].getElementsByTagName("a")
            for(let subItem of subItems){
              if(pathName==subItem.pathName){
                flag = true
                break
              }
            }
          }else{
            flag = true
          }

          if(flag){
            break
          }

        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem,pathName)
      }
    }

    initMenu()

  }, [])

  useEffect(() => {
    ref.current.recalculate()
  })



  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item, path) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
      for(let child of parent2El.childNodes){
       if(child.childNodes[0].pathname == path){
        child.childNodes[0].classList.add("mm-active")
        break
       }
      }
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">


            {fullMenu}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  menuItems: PropTypes.array,
  layout: PropTypes.object,
  t: PropTypes.any,
}

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
    menuItems: state.Menu.menuItems,
  };
};

//export default withRouter(withTranslation()(SidebarContent))

export default connect(mapStatetoProps)(withRouter(withTranslation()(SidebarContent)))